(ns web3.routers.drawer
  (:require [web3.screens.sponsor :as sponsor]
            [web3.screens.service-provider :as service-provider]
            [web3.screens.property :as property]
            [web3.screens.drawer :as drawer]
            [web3.screens.marketing :as marketing]
            [web3.screens.profile :as profile]))

(def router
  {:paths
   [""
    {"" :account/menu
     "sponsor" :account/sponsor
     "profile"
     {"" :account/profile
      "/change-password" :account/change-password}
     "support"
     {"" :account/support}
     ;; ["/page/" :page-id] :account.support/page
     "properties"
     {"" :properties/index
      ["/detail/" :property-id] :properties/detail}
     "service-providers"
     {"" :service-providers/index
      ["/detail/" :service-provider-id] :service-providers/detail}
     "tell-a-friend" :marketing/tell-a-friend
     "social-media" :marketing/social}]

   :handlers {:account/menu drawer/drawer-home
              :account/sponsor sponsor/contact-information
              :account/profile profile/detail
              :account/change-password profile/change-password
              :account/support drawer/support

              :marketing/tell-a-friend marketing/tell-a-friend
              :marketing/social drawer/social

              ;; :account.support/page  drawer/support-page

              :properties/index property/index
              :properties/detail property/detail

              :service-providers/index service-provider/index
              :service-providers/detail service-provider/detail}})

